import { fetchAuthSession } from "aws-amplify/auth";

export const getFreshToken = async () => {
  try {
    const refreshedSession = await fetchAuthSession({ forceRefresh: true });
    const refreshedToken = refreshedSession.tokens?.accessToken;
    return refreshedToken;
  } catch (error) {
    console.error('Error refreshing token:', error);
    throw error;
  }
}
